import React, { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const Discord: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="Discord"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 36"
          fill="none"
          {...props}
        >
          <g clipPath="url(#clip0_17798_40)">
            <path
              d="M40.4479 3.4312C37.3818 2.04212 34.145 1.05666 30.8202 0.5C30.3652 1.30486 29.9535 2.13294 29.5869 2.9808C26.0453 2.45268 22.4437 2.45268 18.9021 2.9808C18.5352 2.13303 18.1236 1.30495 17.6688 0.5C14.3418 1.06137 11.1029 2.04916 8.03374 3.43846C1.94072 12.3592 0.288997 21.0583 1.11486 29.634C4.68308 32.2428 8.67695 34.2269 12.9228 35.5C13.8789 34.2276 14.7249 32.8777 15.4518 31.4646C14.0711 30.9543 12.7385 30.3247 11.4693 29.5831C11.8033 29.3434 12.13 29.0964 12.4457 28.8567C16.1386 30.5752 20.1691 31.4663 24.25 31.4663C28.3308 31.4663 32.3614 30.5752 36.0543 28.8567C36.3736 29.1146 36.7003 29.3616 37.0306 29.5831C35.7591 30.3259 34.424 30.9567 33.0408 31.4682C33.7669 32.8806 34.6129 34.2294 35.5698 35.5C39.8193 34.232 43.8162 32.2489 47.3851 29.6376C48.3541 19.6926 45.7297 11.0734 40.4479 3.4312ZM16.4979 24.36C14.1965 24.36 12.2952 22.2933 12.2952 19.7507C12.2952 17.2082 14.1304 15.1233 16.4906 15.1233C18.8507 15.1233 20.7373 17.2082 20.6969 19.7507C20.6566 22.2933 18.8433 24.36 16.4979 24.36ZM32.0021 24.36C29.697 24.36 27.803 22.2933 27.803 19.7507C27.803 17.2082 29.6383 15.1233 32.0021 15.1233C34.3659 15.1233 36.2378 17.2082 36.1974 19.7507C36.1571 22.2933 34.3475 24.36 32.0021 24.36Z"
              fill="#5F6CFD"
            />
          </g>
          <defs>
            <clipPath id="clip0_17798_40">
              <rect
                width="46.6667"
                height="35"
                fill="white"
                transform="translate(0.916687 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default Discord;
